import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";
import "./LoginForm.css";
import "../../../styles/Variables.css";
import backgroundImage from "../../../img/Header_Accueil_Vehidoc.webp";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import PageWrapper from "../../common/PageWrapper";

const LoginForm = ({ menuState }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const { isMenuOpen, onMenuToggle } = menuState || {};

  const [formData, setFormData] = useState({
    identifier: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [expiredMessage, setExpiredMessage] = useState("");

  // Affichage du message en cas de déconnexion par un autre utilisateur
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const reason = params.get("expired");
    if (reason === "replaced") {
      setExpiredMessage("Vous avez été déconnecté, si le problème persiste contactez rapidement SIPCO.");
    } else if (reason === "expired") {
      setExpiredMessage("Votre session a expiré. Veuillez vous reconnecter.")
    }
  }, [location])

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setExpiredMessage("");

    // Trim whitespace without changing case
    const credentials = {
      identifier: formData.identifier.trim(),
      password: formData.password.trim(),
    };


    try {
      const userData = await login(credentials);

      if (!userData?.statut) throw new Error("Statut utilisateur introuvable");

      switch (userData.statut) {
        case "admin":
          navigate("/admin-dashboard");
          break;
        case "assistante":
          navigate("/assistante-dashboard");
          break;
        case "commercial":
          navigate("/commercial-dashboard");
          break;
        default:
          throw new Error("Statut utilisateur inconnu");
      }
    } catch (err) {
      console.error("❌ Erreur de connexion:", err);
      setError(err.message || "Identifiant ou mot de passe incorrect");
    }
  };


useEffect(() => {
  document.body.classList.add("login-page");
  return () => {
    document.body.classList.remove("login-page");
  };
}, []);

  return (
    <>
      <Header onMenuToggle={onMenuToggle} />
      <PageWrapper isMenuOpen={isMenuOpen} className="login-page">
        <div
          className="form-container"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <form onSubmit={handleSubmit} method="POST">
            {/* En-tête du formulaire */}
            <div className="form-header">
              <h2>Bienvenue</h2>
              <p>
                Bienvenue sur votre espace de connexion VéhiDoc. Créez et gérez
                les profils de votre équipe, ainsi que votre base de données
                véhicules.
              </p>
            </div>
  
            {/* Message d'erreur si nécessaire */}
            {expiredMessage && <div className="error-message">{expiredMessage}</div>}
            {error && <div className="error-message">{error}</div>}
  
            {/* Champ Identifiant */}
            <div className="form-group">
              <label htmlFor="identifier">Identifiant :</label>
              <input
                id="identifier"
                type="text"
                name="identifier"
                placeholder="Identifiant"
                value={formData.identifier}
                onChange={(e) =>
                  setFormData({ ...formData, identifier: e.target.value })
                }
                required
              />
            </div>
  
            {/* Champ Mot de passe */}
            <div className="form-group">
              <label htmlFor="password">Mot de passe :</label>
              <input
                id="password"
                type="password"
                name="password"
                placeholder="Mot de passe"
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                required
              />
            </div>
  
            {/* Bouton de connexion */}
            <button type="submit">Se connecter</button>
          </form>
        </div>
        <Footer />
      </PageWrapper>
    </>
  );
  
};

LoginForm.propTypes = {
  menuState: PropTypes.shape({
    isMenuOpen: PropTypes.bool,
    onMenuToggle: PropTypes.func,
  }),
};

export default LoginForm;
